// Game Data for Creative, Puzzle, and Brain Games

// Coloring book images (SVG paths for simple shapes)
export const coloringImages = [
  {
    id: "star",
    name_it: "Stella",
    name_en: "Star",
    icon: "⭐",
    paths: [
      { d: "M50 5 L61 40 L98 40 L68 62 L79 97 L50 75 L21 97 L32 62 L2 40 L39 40 Z", fill: "#ffffff", stroke: "#333" }
    ]
  },
  {
    id: "heart",
    name_it: "Cuore",
    name_en: "Heart",
    icon: "❤️",
    paths: [
      { d: "M50 88 C20 60 5 40 5 25 C5 10 20 5 35 5 C45 5 50 15 50 15 C50 15 55 5 65 5 C80 5 95 10 95 25 C95 40 80 60 50 88 Z", fill: "#ffffff", stroke: "#333" }
    ]
  },
  {
    id: "house",
    name_it: "Casa",
    name_en: "House",
    icon: "🏠",
    paths: [
      { d: "M50 10 L90 50 L90 90 L10 90 L10 50 Z", fill: "#ffffff", stroke: "#333" },
      { d: "M35 90 L35 65 L50 65 L50 90", fill: "#ffffff", stroke: "#333" },
      { d: "M60 55 L75 55 L75 70 L60 70 Z", fill: "#ffffff", stroke: "#333" }
    ]
  },
  {
    id: "flower",
    name_it: "Fiore",
    name_en: "Flower",
    icon: "🌸",
    paths: [
      { d: "M50 50 m-15 0 a15 15 0 1 0 30 0 a15 15 0 1 0 -30 0", fill: "#ffffff", stroke: "#333" },
      { d: "M50 20 a10 10 0 1 1 0 0.1", fill: "#ffffff", stroke: "#333" },
      { d: "M50 80 a10 10 0 1 1 0 0.1", fill: "#ffffff", stroke: "#333" },
      { d: "M20 50 a10 10 0 1 1 0 0.1", fill: "#ffffff", stroke: "#333" },
      { d: "M80 50 a10 10 0 1 1 0 0.1", fill: "#ffffff", stroke: "#333" },
      { d: "M45 90 L45 65 L55 65 L55 90", fill: "#ffffff", stroke: "#333" }
    ]
  },
  {
    id: "butterfly",
    name_it: "Farfalla",
    name_en: "Butterfly",
    icon: "🦋",
    paths: [
      { d: "M50 30 Q20 10 15 50 Q20 90 50 70 Q80 90 85 50 Q80 10 50 30", fill: "#ffffff", stroke: "#333" },
      { d: "M50 30 L50 85", fill: "none", stroke: "#333" }
    ]
  },
  {
    id: "car",
    name_it: "Auto",
    name_en: "Car",
    icon: "🚗",
    paths: [
      { d: "M10 60 L10 75 L90 75 L90 60 L75 60 L70 45 L30 45 L25 60 Z", fill: "#ffffff", stroke: "#333" },
      { d: "M25 75 a10 10 0 1 0 0 0.1", fill: "#ffffff", stroke: "#333" },
      { d: "M75 75 a10 10 0 1 0 0 0.1", fill: "#ffffff", stroke: "#333" },
      { d: "M35 60 L40 50 L60 50 L65 60 Z", fill: "#ffffff", stroke: "#333" }
    ]
  },
  {
    id: "fish",
    name_it: "Pesce",
    name_en: "Fish",
    icon: "🐟",
    paths: [
      { d: "M80 50 Q60 20 30 50 Q60 80 80 50", fill: "#ffffff", stroke: "#333" },
      { d: "M20 50 L5 35 L5 65 Z", fill: "#ffffff", stroke: "#333" },
      { d: "M60 45 a3 3 0 1 0 0 0.1", fill: "#333", stroke: "#333" }
    ]
  },
  {
    id: "sun",
    name_it: "Sole",
    name_en: "Sun",
    icon: "☀️",
    paths: [
      { d: "M50 50 m-20 0 a20 20 0 1 0 40 0 a20 20 0 1 0 -40 0", fill: "#ffffff", stroke: "#333" },
      { d: "M50 5 L50 20", fill: "none", stroke: "#333", strokeWidth: 3 },
      { d: "M50 80 L50 95", fill: "none", stroke: "#333", strokeWidth: 3 },
      { d: "M5 50 L20 50", fill: "none", stroke: "#333", strokeWidth: 3 },
      { d: "M80 50 L95 50", fill: "none", stroke: "#333", strokeWidth: 3 },
      { d: "M18 18 L28 28", fill: "none", stroke: "#333", strokeWidth: 3 },
      { d: "M72 72 L82 82", fill: "none", stroke: "#333", strokeWidth: 3 },
      { d: "M82 18 L72 28", fill: "none", stroke: "#333", strokeWidth: 3 },
      { d: "M28 72 L18 82", fill: "none", stroke: "#333", strokeWidth: 3 }
    ]
  }
];

// Puzzle images (using emoji for simplicity)
export const puzzleImages = [
  { id: "cat", emoji: "🐱", name_it: "Gatto", name_en: "Cat" },
  { id: "dog", emoji: "🐶", name_it: "Cane", name_en: "Dog" },
  { id: "lion", emoji: "🦁", name_it: "Leone", name_en: "Lion" },
  { id: "elephant", emoji: "🐘", name_it: "Elefante", name_en: "Elephant" },
  { id: "dinosaur", emoji: "🦕", name_it: "Dinosauro", name_en: "Dinosaur" },
  { id: "rocket", emoji: "🚀", name_it: "Razzo", name_en: "Rocket" },
  { id: "rainbow", emoji: "🌈", name_it: "Arcobaleno", name_en: "Rainbow" },
  { id: "unicorn", emoji: "🦄", name_it: "Unicorno", name_en: "Unicorn" }
];

// Brain Games - Find the Odd One
export const oddOneOutGames = {
  easy: [ // 6-7 years
    { items: ["🍎", "🍎", "🍎", "🍌"], answer: 3, hint_it: "Cerca il frutto diverso", hint_en: "Find the different fruit" },
    { items: ["🐶", "🐶", "🐱", "🐶"], answer: 2, hint_it: "Quale animale è diverso?", hint_en: "Which animal is different?" },
    { items: ["🔴", "🔴", "🔵", "🔴"], answer: 2, hint_it: "Quale colore è diverso?", hint_en: "Which color is different?" },
    { items: ["⭐", "⭐", "⭐", "🌙"], answer: 3, hint_it: "Cerca quello diverso", hint_en: "Find the different one" },
    { items: ["🚗", "🚗", "✈️", "🚗"], answer: 2, hint_it: "Quale va in cielo?", hint_en: "Which goes in the sky?" },
    { items: ["2", "4", "6", "7"], answer: 3, hint_it: "Quale numero è dispari?", hint_en: "Which number is odd?" },
    { items: ["🌸", "🌸", "🌵", "🌸"], answer: 2, hint_it: "Quale pianta è diversa?", hint_en: "Which plant is different?" },
    { items: ["🍕", "🍕", "🍕", "🎂"], answer: 3, hint_it: "Quale non è pizza?", hint_en: "Which is not pizza?" },
    { items: ["🐟", "🐟", "🐦", "🐟"], answer: 2, hint_it: "Quale non vive nell'acqua?", hint_en: "Which doesn't live in water?" },
    { items: ["🍇", "🍓", "🍒", "🥦"], answer: 3, hint_it: "Quale è una verdura?", hint_en: "Which is a vegetable?" },
    { items: ["😀", "😀", "😢", "😀"], answer: 2, hint_it: "Quale faccina è triste?", hint_en: "Which face is sad?" },
    { items: ["🔺", "🔺", "🔺", "⬛"], answer: 3, hint_it: "Quale forma è diversa?", hint_en: "Which shape is different?" },
    { items: ["🐝", "🐝", "🦋", "🐝"], answer: 2, hint_it: "Quale insetto è diverso?", hint_en: "Which bug is different?" },
    { items: ["☀️", "☀️", "☀️", "❄️"], answer: 3, hint_it: "Quale è freddo?", hint_en: "Which one is cold?" },
    { items: ["1", "3", "5", "4"], answer: 3, hint_it: "Quale numero è pari?", hint_en: "Which number is even?" },
    { items: ["🍦", "🍦", "🌭", "🍦"], answer: 2, hint_it: "Quale non è un gelato?", hint_en: "Which is not ice cream?" },
    { items: ["🚲", "🚲", "🚲", "⛵"], answer: 3, hint_it: "Quale va sull'acqua?", hint_en: "Which goes on water?" },
    { items: ["🟢", "🟢", "🟡", "🟢"], answer: 2, hint_it: "Quale colore è diverso?", hint_en: "Which color is different?" },
    { items: ["🐘", "🐘", "🐭", "🐘"], answer: 2, hint_it: "Quale animale è piccolo?", hint_en: "Which animal is small?" },
    { items: ["🎈", "🎈", "🎈", "⚽"], answer: 3, hint_it: "Quale non è un palloncino?", hint_en: "Which is not a balloon?" }
  ],
  hard: [ // 8-10 years
    { items: ["🐕", "🐈", "🐁", "🚗"], answer: 3, hint_it: "Quale non è un animale?", hint_en: "Which is not an animal?" },
    { items: ["2", "4", "6", "9"], answer: 3, hint_it: "Quale non è pari?", hint_en: "Which is not even?" },
    { items: ["A", "E", "I", "B"], answer: 3, hint_it: "Quale non è una vocale?", hint_en: "Which is not a vowel?" },
    { items: ["🌍", "🌙", "⭐", "🚀"], answer: 3, hint_it: "Quale non è nello spazio naturalmente?", hint_en: "Which is not naturally in space?" },
    { items: ["3", "6", "9", "11"], answer: 3, hint_it: "Quale non è multiplo di 3?", hint_en: "Which is not a multiple of 3?" },
    { items: ["🍎", "🍊", "🥕", "🍇"], answer: 2, hint_it: "Quale non è un frutto?", hint_en: "Which is not a fruit?" },
    { items: ["IT", "FR", "UK", "EU"], answer: 3, hint_it: "Quale non è un paese?", hint_en: "Which is not a country?" },
    { items: ["H₂O", "CO₂", "NaCl", "ABC"], answer: 3, hint_it: "Quale non è una formula chimica?", hint_en: "Which is not a chemical formula?" },
    { items: ["5", "10", "15", "22"], answer: 3, hint_it: "Quale non è multiplo di 5?", hint_en: "Which is not a multiple of 5?" },
    { items: ["🌹", "🌻", "🌷", "🍄"], answer: 3, hint_it: "Quale non è un fiore?", hint_en: "Which is not a flower?" },
    { items: ["Lun", "Mar", "Mer", "Gen"], answer: 3, hint_it: "Quale non è un giorno?", hint_en: "Which is not a weekday?" },
    { items: ["🎸", "🎹", "🥁", "🎨"], answer: 3, hint_it: "Quale non è uno strumento?", hint_en: "Which is not an instrument?" },
    { items: ["4", "9", "16", "20"], answer: 3, hint_it: "Quale non è un quadrato perfetto?", hint_en: "Which is not a perfect square?" },
    { items: ["🦈", "🐬", "🐋", "🦅"], answer: 3, hint_it: "Quale non vive in mare?", hint_en: "Which doesn't live in the sea?" },
    { items: ["Roma", "Parigi", "Londra", "Europa"], answer: 3, hint_it: "Quale non è una città?", hint_en: "Which is not a city?" },
    { items: ["2", "3", "5", "8"], answer: 3, hint_it: "Quale non è un numero primo?", hint_en: "Which is not a prime number?" },
    { items: ["🍅", "🥒", "🌽", "🍫"], answer: 3, hint_it: "Quale non è un vegetale?", hint_en: "Which is not a vegetable?" },
    { items: ["🔵", "🟦", "🔷", "🔴"], answer: 3, hint_it: "Quale non è blu?", hint_en: "Which one is not blue?" },
    { items: ["10", "20", "30", "45"], answer: 3, hint_it: "Quale non è multiplo di 10?", hint_en: "Which is not a multiple of 10?" },
    { items: ["🐝", "🐜", "🦋", "🐢"], answer: 3, hint_it: "Quale non è un insetto?", hint_en: "Which is not an insect?" }
  ]
};

// Brain Games - Sequences
export const sequenceGames = {
  easy: [
    { sequence: ["1", "2", "3", "?"], options: ["4", "5", "6"], answer: 0 },
    { sequence: ["🔴", "🔵", "🔴", "?"], options: ["🔵", "🔴", "🟢"], answer: 0 },
    { sequence: ["A", "B", "C", "?"], options: ["D", "E", "A"], answer: 0 },
    { sequence: ["⬆️", "➡️", "⬇️", "?"], options: ["⬅️", "⬆️", "➡️"], answer: 0 },
    { sequence: ["🐣", "🐥", "🐔", "?"], options: ["🥚", "🦅", "🐓"], answer: 2 },
    { sequence: ["😀", "😃", "😄", "?"], options: ["😁", "😢", "😴"], answer: 0 },
    { sequence: ["🌱", "🌿", "🌳", "?"], options: ["🍂", "🌱", "🌸"], answer: 0 },
    { sequence: ["2", "4", "6", "?"], options: ["7", "8", "9"], answer: 1 }
  ],
  hard: [
    { sequence: ["2", "4", "8", "?"], options: ["10", "12", "16"], answer: 2 },
    { sequence: ["1", "1", "2", "3", "?"], options: ["4", "5", "6"], answer: 1 },
    { sequence: ["🔺", "🔺🔺", "🔺🔺🔺", "?"], options: ["🔺🔺🔺🔺", "🔺🔺", "🔺"], answer: 0 },
    { sequence: ["Z", "Y", "X", "?"], options: ["A", "W", "V"], answer: 1 },
    { sequence: ["1", "4", "9", "?"], options: ["12", "16", "25"], answer: 1 },
    { sequence: ["🌑", "🌓", "🌕", "?"], options: ["🌗", "🌑", "🌙"], answer: 0 },
    { sequence: ["3", "6", "12", "?"], options: ["18", "24", "15"], answer: 1 },
    { sequence: ["Mon", "Wed", "Fri", "?"], options: ["Sat", "Sun", "Thu"], answer: 1 }
  ]
};

// Memory game pairs
export const memoryPairs = [
  "🐶", "🐱", "🐭", "🐹", "🐰", "🦊", "🐻", "🐼",
  "🦁", "🐯", "🐨", "🐮", "🐷", "🐸", "🐵", "🐔",
  "🦄", "🐴", "🦋", "🐝", "🐞", "🦀", "🐙", "🐠"
];

// Brain riddles/visual puzzles
export const riddleGames = {
  easy: [
    { question_it: "Quante zampe hanno 2 cani?", question_en: "How many legs do 2 dogs have?", image: "🐕🐕", options: ["4", "6", "8"], answer: 2 },
    { question_it: "Se ho 3 mele e ne mangio 1, quante ne restano?", question_en: "If I have 3 apples and eat 1, how many are left?", image: "🍎🍎🍎", options: ["1", "2", "3"], answer: 1 },
    { question_it: "Quale viene prima: colazione o pranzo?", question_en: "Which comes first: breakfast or lunch?", image: "🍳🍝", options: ["Colazione", "Pranzo", "Cena"], answer: 0 },
    { question_it: "Quanti lati ha un triangolo?", question_en: "How many sides does a triangle have?", image: "🔺", options: ["2", "3", "4"], answer: 1 },
    { question_it: "Cosa viene dopo l'inverno?", question_en: "What comes after winter?", image: "❄️➡️?", options: ["Estate", "Autunno", "Primavera"], answer: 2 },
    { question_it: "Quante ruote ha una bicicletta?", question_en: "How many wheels does a bicycle have?", image: "🚲", options: ["1", "2", "3"], answer: 1 },
    { question_it: "Di che colore è il cielo sereno di giorno?", question_en: "What color is the clear sky during the day?", image: "☀️🌤️", options: ["Verde", "Azzurro", "Rosso"], answer: 1 },
    { question_it: "Quanti giorni ci sono in una settimana?", question_en: "How many days are there in a week?", image: "📆", options: ["5", "7", "10"], answer: 1 },
    { question_it: "Cosa usiamo per vedere?", question_en: "What do we use to see?", image: "👀", options: ["Le orecchie", "Il naso", "Gli occhi"], answer: 2 },
    { question_it: "Se metti insieme 2 e 2, quanto fa?", question_en: "If you put 2 and 2 together, how much is it?", image: "✌️➕✌️", options: ["3", "4", "5"], answer: 1 },
    { question_it: "Quale animale fa 'muuu'?", question_en: "Which animal says 'moo'?", image: "🐮", options: ["Il cane", "La mucca", "Il gatto"], answer: 1 },
    { question_it: "Quanti pollici ha una mano?", question_en: "How many thumbs does one hand have?", image: "✋", options: ["1", "2", "5"], answer: 0 },
    { question_it: "Cosa cade dal cielo quando piove?", question_en: "What falls from the sky when it rains?", image: "🌧️", options: ["Acqua", "Sabbia", "Foglie"], answer: 0 },
    { question_it: "Quale è più grande: un topo o un elefante?", question_en: "Which is bigger: a mouse or an elephant?", image: "🐭🐘", options: ["Il topo", "L'elefante", "Uguali"], answer: 1 },
    { question_it: "Se sono le 3 e passano 2 ore, che ore sono?", question_en: "If it's 3 o'clock and 2 hours pass, what time is it?", image: "🕒", options: ["Le 4", "Le 5", "Le 6"], answer: 1 },
    { question_it: "Quante dita ci sono in due mani?", question_en: "How many fingers are there on two hands?", image: "🙌", options: ["5", "10", "20"], answer: 1 },
    { question_it: "Cosa fa la luce quando entri in una stanza buia e premi l'interruttore?", question_en: "What happens when you flip the switch in a dark room?", image: "💡", options: ["Si accende", "Si rompe", "Scompare"], answer: 0 },
    { question_it: "Quale frutto è giallo e lo mangiano le scimmie?", question_en: "Which fruit is yellow and monkeys love it?", image: "🍌", options: ["Mela", "Banana", "Uva"], answer: 1 }
  ],
  hard: [
    { question_it: "Un contadino ha 17 pecore. Tutte tranne 9 scappano. Quante ne restano?", question_en: "A farmer has 17 sheep. All but 9 run away. How many are left?", image: "🐑", options: ["8", "9", "17"], answer: 1 },
    { question_it: "Quanti mesi hanno 28 giorni?", question_en: "How many months have 28 days?", image: "📅", options: ["1", "12", "Solo febbraio"], answer: 1 },
    { question_it: "Se 5 gatti catturano 5 topi in 5 minuti, quanti gatti servono per catturare 100 topi in 100 minuti?", question_en: "If 5 cats catch 5 mice in 5 minutes, how many cats to catch 100 mice in 100 minutes?", image: "🐱🐭", options: ["100", "20", "5"], answer: 2 },
    { question_it: "Un mattone pesa 1kg più mezzo mattone. Quanto pesa il mattone?", question_en: "A brick weighs 1kg plus half a brick. How much does the brick weigh?", image: "🧱", options: ["1.5 kg", "2 kg", "1 kg"], answer: 1 },
    { question_it: "Cosa puoi tenere senza mai toccare?", question_en: "What can you hold without ever touching?", image: "🤔", options: ["Una promessa", "Una palla", "Un libro"], answer: 0 },
    { question_it: "Più ne togli, più diventa grande. Cosa è?", question_en: "The more you take away, the bigger it gets. What is it?", image: "🕳️", options: ["Un buco", "Una torta", "Una scala"], answer: 0 },
    { question_it: "Ho città ma niente case, montagne ma niente alberi. Cosa sono?", question_en: "I have cities but no houses, mountains but no trees. What am I?", image: "🗺️", options: ["Una mappa", "Un libro", "Un quadro"], answer: 0 },
    { question_it: "Cosa diventa più bagnato più asciuga?", question_en: "What gets wetter the more it dries?", image: "🧻", options: ["Un asciugamano", "Una spugna", "Il sole"], answer: 0 },
    { question_it: "Quanti quadrati ci sono in una scacchiera 2x2?", question_en: "How many squares are in a 2x2 board?", image: "🔲", options: ["4", "5", "6"], answer: 1 },
    { question_it: "Se un aereo si schianta al confine tra Italia e Francia, dove seppelliscono i sopravvissuti?", question_en: "If a plane crashes on the border, where do you bury the survivors?", image: "✈️", options: ["In Italia", "In Francia", "Da nessuna parte"], answer: 2 },
    { question_it: "Cammino ma non ho gambe, ho una faccia ma non parlo. Cosa sono?", question_en: "I run but have no legs, I have a face but don't speak. What am I?", image: "🕰️", options: ["Un orologio", "Un fiume", "Un robot"], answer: 0 },
    { question_it: "Qual è il numero che, letto allo specchio, resta uguale?", question_en: "Which number reads the same in a mirror?", image: "🔢", options: ["6", "8", "9"], answer: 1 },
    { question_it: "Ho i denti ma non mordo. Cosa sono?", question_en: "I have teeth but do not bite. What am I?", image: "🪮", options: ["Un pettine", "Un cane", "Uno squalo"], answer: 0 },
    { question_it: "Se aggiungi 1 a 199 e poi dividi per 2, quanto ottieni?", question_en: "Add 1 to 199 then divide by 2. What do you get?", image: "➗", options: ["100", "99", "101"], answer: 0 },
    { question_it: "Cosa sale ma non scende mai?", question_en: "What goes up but never comes down?", image: "🎂", options: ["La tua età", "Un palloncino", "Un ascensore"], answer: 0 },
    { question_it: "Un uomo compra 3 mele al mercato. Ne mangia 1 e ne regala 1. Quante ne ha ora?", question_en: "A man buys 3 apples, eats 1 and gives away 1. How many now?", image: "🍏", options: ["1", "2", "3"], answer: 0 },
    { question_it: "Sono leggera come una piuma, ma nessuno può trattenermi a lungo. Cosa sono?", question_en: "I'm as light as a feather, yet no one can hold me for long. What am I?", image: "💨", options: ["Il respiro", "Una nuvola", "Il fumo"], answer: 0 },
    { question_it: "Se tre galline fanno tre uova in tre giorni, quante uova fa una gallina in un giorno?", question_en: "If 3 hens lay 3 eggs in 3 days, how many eggs does 1 hen lay in 1 day?", image: "🐔🥚", options: ["1", "1/3", "3"], answer: 1 }
  ]
};

// Available colors for drawing/coloring
export const drawingColors = [
  "#FF0000", "#FF6B00", "#FFD700", "#00FF00", "#00CED1",
  "#0000FF", "#8B00FF", "#FF69B4", "#8B4513", "#000000",
  "#FFFFFF", "#808080", "#FFB6C1", "#98FB98", "#87CEEB"
];
